import Typography from 'antd/lib/typography';
import React from 'react';
import Slider from 'antd/lib/slider';
import './BaseFilterSlider.css';

interface IBaseFilterSliderProps {
    label?: string;
    description?: string;
    defaultValue: [number, number];
    value: [number, number] | undefined;
    min: number;
    max: number;
    onChange: (value: [number, number]) => void;
    valueFormatter?: (value?: number) => React.ReactNode;
    disabled?: boolean;
}

export const BaseFilterSlider: React.FC<IBaseFilterSliderProps> = ({
    label,
    description,
    value,
    defaultValue,
    min,
    max,
    onChange,
    valueFormatter,
    disabled = false,
}) => {
    const myRef: React.RefObject<HTMLInputElement> = React.createRef();

    if (typeof value === 'undefined') {
        value = [...defaultValue];
    }

    if (!valueFormatter) {
        valueFormatter = (value?: number) => `${value}`;
    }

    function onSliderChange(value: number[]) {
        onChange([value[0], value[1]]);
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 15px' }}>
            {description && <Typography.Text style={{ fontSize: '12px', lineHeight: 1 }}>{description}</Typography.Text>}

            <div className="base-filter-slider" style={{ width: '210px' }}>
                {label && <div className="base-filter-slider__label">{label}</div>}
                <div ref={myRef} style={{ position: 'relative', width: '100%', padding: '0 10px' }}>
                    <Slider
                        range
                        min={min}
                        max={max}
                        value={value}
                        defaultValue={defaultValue}
                        onChange={onSliderChange}
                        disabled={disabled}
                        style={{ width: '100%', height: '60px' }}
                        tooltip={{
                            open: true,
                            autoAdjustOverflow: false,
                            placement: 'bottom',
                            getPopupContainer: (triggerNode: HTMLElement) => myRef.current!,
                            formatter: valueFormatter,
                        }}
                        styles={{
                            track: {
                                background: '#5a88a5',
                            },
                            handle: {
                                background: '#5a88a5',
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
